module.exports = __webpack_public_path__ + "img/HNG-1440.1642bb52.jpg";